import * as React from "react";
export const FilterMultiplyIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
      <path
        fill="none"
        stroke="#6d7278"
        strokeWidth="2"
        d="M1 1L15 15M15 1L1 15"
      />
    </svg>
  );
};
